"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[8872],{

/***/ 23198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZR": () => (/* binding */ $85db97acb978e03b$export$b3611e87cd5ba6ce),
/* harmony export */   "iV": () => (/* binding */ $85db97acb978e03b$export$5261e812c31263e7)
/* harmony export */ });
/* unused harmony export ConfigContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);





const $85db97acb978e03b$export$a92f85ab3e9ad68b = /*#__PURE__*/ (0, react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
/**
 * This is an opinionated component in that if there config has been not been
 * passed, or it has failed to fetch, then it will not render its children.
 *
 * This saves the callers of useConfig from checking if the config is set or not.
 * Tradeoff is appropriate as it does not make sense for the app to run without config.
 */ function $85db97acb978e03b$export$5261e812c31263e7({ children: children , configServicePath: configServicePath = "/config" , initialConfig: initialConfig , loadingElement: loadingElement = null , errorElement: errorElement = null  }) {
    const [config, setConfig] = (0, react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialConfig);
    const [error, setError] = (0, react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0, react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (initialConfig) return;
        async function fetchConfig() {
            try {
                const response = await fetch(configServicePath);
                const json = await response.json();
                setConfig(json);
            } catch (e) {
                setError(error);
            }
        }
        fetchConfig();
    }, []);
    if (error) return errorElement;
    if (!config) return loadingElement;
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($85db97acb978e03b$export$a92f85ab3e9ad68b.Provider, {
        value: config,
        children: children
    });
}
function $85db97acb978e03b$export$b3611e87cd5ba6ce() {
    const context = (0, react__WEBPACK_IMPORTED_MODULE_1__).useContext($85db97acb978e03b$export$a92f85ab3e9ad68b);
    if (context === undefined) throw new Error("useConfig must be used within a ConfigProvider");
    return context;
}





//# sourceMappingURL=module.js.map


/***/ }),

/***/ 37671:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kc": () => (/* binding */ $9534a0f5449b6b6b$export$2e2bcd8739ae039),
/* harmony export */   "ub": () => (/* binding */ $9534a0f5449b6b6b$export$b2284bc9e63a24aa)
/* harmony export */ });
/* unused harmony exports explicitlyDisabled, explicitlyEnabled */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57145);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44450);
/* harmony import */ var _material_ui_icons_OfflineBolt__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7363);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40374);
/* harmony import */ var _material_ui_core_SwipeableDrawer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(91223);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(61800);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32333);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(948);
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91241);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95061);
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13713);
/* harmony import */ var _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90010);
/* harmony import */ var _material_ui_core_CardHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81883);
/* harmony import */ var _material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49929);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81381);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18464);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80758);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35795);









































const $e32fa35ccd801d94$var$useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    wrapper: {
        width: '100%',
        height: '100%'
    },
    header: {
        paddingBottom: 0
    },
    content: {
        paddingTop: 0
    },
    scrollable: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 250,
        overflowY: 'scroll'
    },
    input: {
        width: '100%'
    },
    checkbox: {
        padding: 2
    },
    formLabel: {
        marginLeft: 0
    }
});
const $e32fa35ccd801d94$var$FeatureFlagsWidget = ({ featureFlags: featureFlags , onFeatureFlagChange: onFeatureFlagChange ,  })=>{
    const [filter, setFilter] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(sessionStorage.getItem('dev-tools.featureFlagWidget.filter') || '');
    const classes = $e32fa35ccd801d94$var$useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.wrapper,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Feature Flags",
                className: classes.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: classes.input,
                        label: "Filter",
                        value: filter,
                        autoFocus: true,
                        onChange: (e)=>{
                            const value = e.target.value.toLowerCase();
                            setFilter(value);
                            sessionStorage.setItem('dev-tools.featureFlagWidget.filter', value);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.scrollable,
                        children: Object.entries(featureFlags).filter(([flagName])=>flagName.toLowerCase().includes(filter)
                        ).sort((a, b)=>a[0].localeCompare(b[0])
                        ).map(([flagName, flagValue])=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: classes.formLabel,
                                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    className: classes.checkbox,
                                    checked: Boolean(flagValue),
                                    onChange: ()=>onFeatureFlagChange({
                                            [flagName]: !flagValue
                                        })
                                    ,
                                    name: flagName
                                }),
                                label: flagName
                            }, flagName)
                        )
                    })
                ]
            })
        ]
    });
};
var $e32fa35ccd801d94$export$2e2bcd8739ae039 = $e32fa35ccd801d94$var$FeatureFlagsWidget;








const $07432a3cfb35b669$var$useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    wrapper: {
        width: '100%',
        height: '100%'
    },
    header: {
        paddingBottom: 0
    },
    content: {
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 310,
        overflowY: 'scroll'
    },
    checkbox: {
        padding: 2
    },
    formLabel: {
        marginLeft: 0
    }
});
const $07432a3cfb35b669$var$ConfigWidget = ({ config: config  })=>{
    const classes = $07432a3cfb35b669$var$useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.wrapper,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Config",
                className: classes.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: classes.content,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
                    children: JSON.stringify(config, null, 2)
                })
            })
        ]
    });
};
var $07432a3cfb35b669$export$2e2bcd8739ae039 = $07432a3cfb35b669$var$ConfigWidget;












const $568b7a9585f959d4$var$useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((theme)=>({
        wrapper: {
            width: '100%',
            height: '100%'
        },
        header: {
            paddingBottom: 0
        },
        content: {
            paddingTop: 0,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 310,
            overflowY: 'scroll',
            '& > *': {
                margin: theme.spacing(1),
                width: '35ch'
            }
        },
        checkbox: {
            padding: 2
        },
        formLabel: {
            marginLeft: 0
        }
    })
);
const $568b7a9585f959d4$var$UserWidget = ({ user: user , setUserLanguage: setUserLanguage  })=>{
    const classes = $568b7a9585f959d4$var$useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.wrapper,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "User",
                className: classes.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_CardContent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                htmlFor: "language-native-simple",
                                children: 'Language'
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                native: true,
                                value: user?.language,
                                onChange: (e)=>setUserLanguage?.(e.target.value)
                                ,
                                inputProps: {
                                    name: 'Language',
                                    id: 'language-native-simple'
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "en",
                                        children: 'en'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "te-st",
                                        children: 'te-st'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "fr",
                                        children: 'fr'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "es-mx",
                                        children: 'es-mx'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: "Email",
                        value: user?.email ?? '',
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: "Role",
                        value: user?.roleName ?? '',
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: "User Id",
                        value: user?.userId ?? '',
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: "Clinic",
                        value: user?.facilityId ?? '',
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        label: "Organisation",
                        value: user?.organisationId ?? '',
                        disabled: true
                    })
                ]
            })
        ]
    });
};
var $568b7a9585f959d4$export$2e2bcd8739ae039 = $568b7a9585f959d4$var$UserWidget;


const $4ccede0c66f0a4d8$var$useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    openIcon: {
        position: 'fixed',
        bottom: 10,
        left: 10,
        zIndex: 1
    },
    header: {
        position: 'absolute',
        right: 0,
        padding: 5
    },
    body: {
        padding: 20,
        display: 'flex',
        justifyContent: 'space-between',
        height: 400
    },
    grid: {
        flexGrow: 1
    }
});
const $4ccede0c66f0a4d8$var$theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
    palette: {
        type: 'dark'
    }
});
function $4ccede0c66f0a4d8$var$useHotKeyToggle(isOpen, setOpen) {
    const isOpenRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(isOpen);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener('keydown', (event)=>{
            // cmd + e
            if ((event.ctrlKey || event.metaKey) && event.code === 'KeyE') setOpen(!isOpenRef.current);
        });
    }, [
        setOpen
    ]);
}
const $4ccede0c66f0a4d8$var$DevTools = ({ appVersion: appVersion , config: config , featureFlags: featureFlags , onFeatureFlagChange: onFeatureFlagChange , user: user , setUserLanguage: setUserLanguage ,  })=>{
    const [isOpen, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    $4ccede0c66f0a4d8$var$useHotKeyToggle(isOpen, setOpen);
    const classes = $4ccede0c66f0a4d8$var$useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                "aria-label": "open dev tools",
                className: classes.openIcon,
                onClick: ()=>setOpen(true)
                ,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                    title: "cmd + e",
                    arrow: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_OfflineBolt__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        fontSize: "large"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                theme: $4ccede0c66f0a4d8$var$theme,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_SwipeableDrawer__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    anchor: "bottom",
                    open: isOpen,
                    onOpen: ()=>setOpen(true)
                    ,
                    onClose: ()=>setOpen(false)
                    ,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classes.header,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                variant: "body2",
                                color: "textSecondary",
                                children: `v${appVersion}`
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            container: true,
                            className: classes.grid,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($e32fa35ccd801d94$export$2e2bcd8739ae039, {
                                        featureFlags: featureFlags,
                                        onFeatureFlagChange: onFeatureFlagChange
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($568b7a9585f959d4$export$2e2bcd8739ae039, {
                                        user: user,
                                        setUserLanguage: setUserLanguage
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($07432a3cfb35b669$export$2e2bcd8739ae039, {
                                        config: config
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $4ccede0c66f0a4d8$export$2e2bcd8739ae039 = $4ccede0c66f0a4d8$var$DevTools;


const $9534a0f5449b6b6b$export$40a80a91cb65c5ad = ()=>window.location.search.includes('dev-tools=false') || window.localStorage.getItem('dev-tools') === 'false'
;
const $9534a0f5449b6b6b$export$39d676103d0fb993 = ()=>window.location.search.includes('dev-tools=true') || window.localStorage.getItem('dev-tools') === 'true'
;
const $9534a0f5449b6b6b$export$b2284bc9e63a24aa = ()=>!$9534a0f5449b6b6b$export$40a80a91cb65c5ad() && $9534a0f5449b6b6b$export$39d676103d0fb993()
;
const $9534a0f5449b6b6b$var$DevToolsProvider = (props)=>{
    if ($9534a0f5449b6b6b$export$b2284bc9e63a24aa()) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($4ccede0c66f0a4d8$export$2e2bcd8739ae039, {
        ...props
    });
    return null;
};
var $9534a0f5449b6b6b$export$2e2bcd8739ae039 = $9534a0f5449b6b6b$var$DevToolsProvider;





//# sourceMappingURL=module.js.map


/***/ }),

/***/ 4031:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* reexport */ Freshdesk)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/esm/CloseOutlined.js
var CloseOutlined = __webpack_require__(60813);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/esm/ChatBubbleOutline.js
var ChatBubbleOutline = __webpack_require__(33749);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.17_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(59490);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(40374);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.14_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(5669);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/positioning.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function makeBlock(_a) {
    var left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
    var block = [];
    if (left)
        block.push("left: ".concat(left, " !important;"));
    if (right)
        block.push("right: ".concat(right, " !important;"));
    if (top)
        block.push("top: ".concat(top, " !important;"));
    if (bottom)
        block.push("bottom: ".concat(bottom, " !important;"));
    return block.join('\n\t');
}
function makeFreshDeskWidgetPositionStyles(position) {
    var _a;
    var breakpointStyles = (_a = position.breakpoints) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
        var maxWidth = _a.maxWidth, style = _a.style;
        return "\n@media (max-width: ".concat(maxWidth, ") {\n  #fc_frame {\n    ").concat(makeBlock(style), "\n  }\n}");
    }).join('\n');
    return "\n#fc_frame {\n  ".concat(makeBlock(position.defaultStyle), "\n  z-index: 100;\n}\n").concat(breakpointStyles || '', "\n    ");
}
function makeDefaultWidgetPositionStyles(position) {
    var _a;
    var breakpoints = {};
    (_a = position.breakpoints) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
        var maxWidth = _a.maxWidth, style = _a.style;
        breakpoints["@media (max-width:".concat(maxWidth, ")")] = style;
    });
    return __assign(__assign({}, position.defaultStyle), breakpoints);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/DefaultHelpWidget.js
var DefaultHelpWidget_assign = (undefined && undefined.__assign) || function () {
    DefaultHelpWidget_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DefaultHelpWidget_assign.apply(this, arguments);
};
/* eslint-disable react/jsx-no-literals */







// A lot of these styles have just been ripped from the Freshdesk widget to try and stay consistent
// We've not added them to the theme because they won't be used anywhere else
var useStyles = (0,dist_module/* makeStyles */.Z)(function () { return ({
    wrapper: function (props) { return (DefaultHelpWidget_assign({ position: 'fixed', bottom: 20, right: 20, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }, (props.positionOverrides &&
        makeDefaultWidgetPositionStyles(props.positionOverrides)))); },
    openIcon: {
        background: '#483c8b !important',
        boxShadow: '0 5px 4px 0 rgb(0 0 0 / 26%)',
        height: '60px',
        width: '60px',
    },
    closeIcon: {
        marginBottom: '5px',
        background: ' #707c92 !important',
        borderRadius: '1rem',
        height: '1.75rem',
        width: '2.5rem',
        opacity: '0.7',
        '&:hover': {
            opacity: '1',
        },
    },
    widget: {
        height: '300px',
        width: '300px',
        background: '#f4f5f7',
        boxShadow: '0 -1px 20px rgb(0 0 0 / 16%)',
        borderRadius: '5px',
        overflow: 'hidden',
    },
    header: {
        width: '100%',
        height: '80px',
        background: '#483c8b',
        display: 'flex',
        alignItems: 'center',
        padding: '20px',
    },
    logo: {
        width: '163px',
        height: '35px',
    },
    body: {
        padding: '15px',
    },
    bodyCard: {
        background: 'white',
        borderRadius: '5px',
        width: '100%',
        boxShadow: '0 2px 4px 0 rgb(0 0 0 / 12%)',
        padding: '8px',
    },
}); });
function getSupportDetails(territory) {
    if (territory === 'kenya') {
        return '+254748369986';
    }
    if (territory === 'ghana') {
        return '+233 50 859 6501';
    }
    return null;
}
var DefaultHelpWidget = function (_a) {
    var territory = _a.territory, emitAnalyticsEvent = _a.emitAnalyticsEvent, positionOverrides = _a.positionOverrides;
    var classes = useStyles({ positionOverrides: positionOverrides });
    var _b = (0,react.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    // Allow this widget to open in place of the freshdesk one if anywhere in the application attempts to
    // use the global window methods to open the widget
    (0,react.useEffect)(function () {
        var _a;
        var previousFcWidget = window.fcWidget;
        var previousOpen = (_a = window.fcWidget) === null || _a === void 0 ? void 0 : _a.open;
        window.fcWidget = DefaultHelpWidget_assign(DefaultHelpWidget_assign({}, previousFcWidget), { open: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                setIsOpen(true);
                if (previousOpen) {
                    previousOpen.apply(void 0, args);
                }
            } });
        return function () {
            window.fcWidget = previousFcWidget;
            if (window.fcWidget) {
                window.fcWidget.open = previousOpen;
            }
        };
    }, [setIsOpen]);
    var supportDetails = getSupportDetails(territory);
    return (react.createElement("div", { className: classes.wrapper }, isOpen ? (react.createElement(react.Fragment, null,
        react.createElement(IconButton/* default */.Z, { "aria-label": formatMessage({
                id: 'defaultHelpWidget.closeLabel',
                defaultMessage: 'close support window',
            }), className: classes.closeIcon, onClick: function () { return setIsOpen(false); } },
            react.createElement(CloseOutlined/* default */.Z, { style: { color: 'white' } })),
        react.createElement("div", { className: classes.widget },
            react.createElement("div", { className: classes.header },
                react.createElement(mui_icon_dist_module/* ElephantLogoIcon */.KL, { className: classes.logo, fill: "white" })),
            react.createElement("div", { className: classes.body },
                react.createElement("div", { className: classes.bodyCard },
                    react.createElement("p", null,
                        react.createElement(message/* default */.Z, { id: "defaultHelpWidget.body1", defaultMessage: "You are unable to use our support chat at the moment. This might be because you are offline or because you have no data left on your device." })),
                    supportDetails ? (react.createElement("p", null,
                        react.createElement(message/* default */.Z, { id: "defaultHelpWidget.body2", defaultMessage: "Please connect to the internet and try again, or contact us at <b>{supportMethod}</b>", values: {
                                // @ts-ignore
                                b: function () {
                                    var chunks = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        chunks[_i] = arguments[_i];
                                    }
                                    return react.createElement("b", null, chunks);
                                },
                                supportMethod: getSupportDetails(territory),
                            } }))) : null))))) : (react.createElement(IconButton/* default */.Z, { "aria-label": formatMessage({
            id: 'defaultHelpWidget.openLabel',
            defaultMessage: 'open support window',
        }), className: classes.openIcon, onClick: function () {
            emitAnalyticsEvent === null || emitAnalyticsEvent === void 0 ? void 0 : emitAnalyticsEvent({
                category: 'freshdesk',
                name: 'freshdesk.fallback_widget.open',
            });
            setIsOpen(true);
        } },
        react.createElement(ChatBubbleOutline/* default */.Z, { style: { color: 'white' } })))));
};
/* harmony default export */ const esm_DefaultHelpWidget = (DefaultHelpWidget);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/routeMatching.js
function matchRoute(currentPath, _a) {
    var path = _a.path, exact = _a.exact;
    if (exact) {
        return currentPath === path;
    }
    return currentPath.includes(path);
}
function matchRoutes(currentPath, routes) {
    return routes.some(function (route) { return matchRoute(currentPath, route); });
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/freshdeskApi.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var identifyUser = function (context) {
    window.fcWidget.setExternalId(context.userId);
    window.fcWidget.user.setFirstName(context.firstName);
    window.fcWidget.user.setLastName(context.lastName);
    window.fcWidget.user.setEmail(context.email);
    window.fcWidget.user.setProperties({
        territory: context.territory,
        environment: context.environment,
        role: context.roleName,
        clinic: context.facilityName,
    });
};
var initFreshChat = function (_a, userContext) {
    var freshdeskToken = _a.freshdeskToken, freshdeskHost = _a.freshdeskHost, emitErrorEvent = _a.emitErrorEvent, onWidgetLoaded = _a.onWidgetLoaded;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            try {
                // Hide Freshdesk widget for e2e users as it messes with some of the tests
                if (userContext.email.match(/(e2e.user|e2etesting).*@elephant\.healthcare/g)) {
                    return [2 /*return*/];
                }
                if (!((_b = window.fcWidget) === null || _b === void 0 ? void 0 : _b.isInitialized())) {
                    // init with freshchat button hidden
                    window.fcWidget.init({
                        token: freshdeskToken,
                        host: freshdeskHost,
                        externalId: userContext.userId,
                        config: {
                            headerProperty: {
                                hideChatButton: true,
                            },
                        },
                    }, window.fcWidget.on('widget:loaded', function () {
                        onWidgetLoaded();
                    }));
                    identifyUser(userContext);
                }
            }
            catch (error) {
                emitErrorEvent === null || emitErrorEvent === void 0 ? void 0 : emitErrorEvent({
                    name: 'freshdesk.init',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    });
};
var freshChatId = 'freshchat-js-sdk';
var loadFreshChat = function (_a) {
    var freshdeskHost = _a.freshdeskHost, onLoad = _a.onLoad, onError = _a.onError;
    if (document.getElementById(freshChatId))
        return;
    // create an element to house the script - this is not the chat widget element
    var el = document.createElement('script');
    el.id = freshChatId;
    el.async = true;
    el.onload = function () { return onLoad(); };
    el.onerror = function () { return onError(); };
    el.src = "".concat(freshdeskHost, "/js/widget.js");
    document.head.appendChild(el);
};
var destroyFreshChat = function (_a) {
    var _b;
    var emitErrorEvent = _a.emitErrorEvent;
    var destroy = (_b = window.fcWidget) === null || _b === void 0 ? void 0 : _b.destroy;
    if (typeof destroy === 'function') {
        destroy();
    }
    else {
        emitErrorEvent === null || emitErrorEvent === void 0 ? void 0 : emitErrorEvent({
            name: 'freshdesk.destroy',
            error: new Error('Error destroying freshdesk chat widget - have they updated their import script?'),
        });
    }
};
// Updates settings to show freshchat button
var showFreshChatButton = function () {
    window.fcWidget.setConfig({
        headerProperty: {
            hideChatButton: false,
        },
    });
};
// Updates settings to hide freshchat button
var hideFreshChatButton = function () {
    window.fcWidget.setConfig({
        headerProperty: {
            hideChatButton: true,
        },
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/Freshdesk.js







var Freshdesk = function (_a) {
    var activeRoutes = _a.activeRoutes, freshdeskToken = _a.freshdeskToken, freshdeskHost = _a.freshdeskHost, emitAnalyticsEvent = _a.emitAnalyticsEvent, emitErrorEvent = _a.emitErrorEvent, positionOverrides = _a.positionOverrides, context = _a.context;
    var pathname = (0,dist/* useLocation */.TH)().pathname;
    var _b = (0,react.useState)(false), freshdeskLoaded = _b[0], setLoaded = _b[1];
    var _c = (0,react.useState)(false), freshdeskFailedToLoad = _c[0], setFreshdeskFailedToLoad = _c[1];
    var _d = (0,react.useState)(false), freshdeskInited = _d[0], setFreshdeskInited = _d[1];
    var _e = (0,react.useState)(false), freshdeskWidgetLoaded = _e[0], setFreshdeskWidgetLoaded = _e[1];
    // Adds Freshdesk <script>
    (0,react.useEffect)(function () {
        if (freshdeskHost && !freshdeskInited) {
            loadFreshChat({
                freshdeskHost: freshdeskHost,
                onLoad: function () { return setLoaded(true); },
                onError: function () { return setFreshdeskFailedToLoad(true); },
            });
            setFreshdeskInited(true);
        }
    }, [freshdeskHost, freshdeskInited]);
    var freshdeskReadyToLoad = !!freshdeskLoaded &&
        !!freshdeskToken &&
        !!freshdeskHost &&
        !!(context === null || context === void 0 ? void 0 : context.userId);
    var widgetShouldBeActiveOnLocation = matchRoutes(pathname, activeRoutes);
    // on each route change inits/deinits Freshdesk
    (0,react.useEffect)(function () {
        if (!freshdeskReadyToLoad)
            return;
        if (widgetShouldBeActiveOnLocation && !freshdeskWidgetLoaded) {
            initFreshChat({
                freshdeskToken: freshdeskToken,
                freshdeskHost: freshdeskHost,
                emitErrorEvent: emitErrorEvent,
                onWidgetLoaded: function () { return setFreshdeskWidgetLoaded(true); },
            }, context);
            return;
        }
        // Check if the widget is loaded & route before showing
        if (freshdeskWidgetLoaded && widgetShouldBeActiveOnLocation) {
            showFreshChatButton();
            return;
        }
        hideFreshChatButton();
    }, [
        pathname,
        freshdeskToken,
        freshdeskHost,
        widgetShouldBeActiveOnLocation,
        freshdeskReadyToLoad,
        freshdeskWidgetLoaded,
        context,
        emitErrorEvent,
        setFreshdeskWidgetLoaded,
    ]);
    var currentPositionOverrides = positionOverrides === null || positionOverrides === void 0 ? void 0 : positionOverrides.find(function (p) {
        return matchRoutes(pathname, p.routes);
    });
    // Useful for sponsored data
    if (freshdeskFailedToLoad && widgetShouldBeActiveOnLocation) {
        return (react.createElement(esm_DefaultHelpWidget, { territory: context.territory, emitAnalyticsEvent: emitAnalyticsEvent, positionOverrides: currentPositionOverrides }));
    }
    return currentPositionOverrides ? (react.createElement("style", null, makeFreshDeskWidgetPositionStyles(currentPositionOverrides))) : null;
};


;// CONCATENATED MODULE: ./node_modules/.pnpm/@elephant-healthcare+freshdesk-widget@2.0.0_sve5xw4qy527pwjp7safk2umlu/node_modules/@elephant-healthcare/freshdesk-widget/dist/esm/index.js



/***/ }),

/***/ 45309:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OH": () => (/* binding */ $c47e547dd869dcf0$export$6d7e43f2d6e1c7c6),
/* harmony export */   "dG": () => (/* binding */ $5687937d771f488b$export$d0ecb7c6d0cc6611),
/* harmony export */   "ye": () => (/* binding */ $d12adac76b8681af$export$61acb772777ef35d)
/* harmony export */ });
/* unused harmony export FeatureFlagContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var launchdarkly_js_client_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63775);







function $093a832bcc65631a$export$a927fc2880676bfa(launchDarklyFlags) {
    return Object.keys(launchDarklyFlags).reduce((acc, key)=>{
        const { current: current  } = launchDarklyFlags[key];
        return {
            [key]: current,
            ...acc
        };
    }, {});
}


let $949892c4694f5c47$var$readyEventFired = false;
const $949892c4694f5c47$var$mockLdClient = {
    onReady: (callback)=>{
        if (!$949892c4694f5c47$var$readyEventFired) {
            $949892c4694f5c47$var$readyEventFired = true;
            callback({});
        }
    },
    onChange: (callback)=>{
        window.e2eSetLaunchDarklyFlags = (flags)=>callback(flags)
        ;
    },
    onFailed: ()=>{},
    onError: ()=>{}
};
function $949892c4694f5c47$export$fa0c409881b4c829({ launchDarklyKey: launchDarklyKey , userId: userId , userEmail: userEmail , launchDarklyRelayUrl: launchDarklyRelayUrl , ...customAttrs }) {
    // switch off feature flag fetching for e2e tests
    if (userEmail.match(/(e2e.user|e2etesting).*@elephant\.healthcare/g)) return $949892c4694f5c47$var$mockLdClient;
    const userAttributes = {
        key: userId,
        email: userEmail,
        custom: customAttrs
    };
    const client = (0,launchdarkly_js_client_sdk__WEBPACK_IMPORTED_MODULE_2__/* .initialize */ .j2)(launchDarklyKey, userAttributes, {
        useReport: true,
        baseUrl: launchDarklyRelayUrl || undefined,
        eventsUrl: launchDarklyRelayUrl || undefined,
        streamUrl: launchDarklyRelayUrl || undefined
    });
    return {
        onReady: (callback)=>client.on('ready', ()=>callback(client.allFlags())
            )
        ,
        onChange: (callback)=>client.on('change', (flags)=>callback($093a832bcc65631a$export$a927fc2880676bfa(flags))
            )
        ,
        onFailed: (callback)=>client.on('failed', callback)
        ,
        onError: (callback)=>client.on('error', callback)
    };
}



const $5687937d771f488b$export$a94f9e4f07f0c0a6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    loading: true,
    flags: {},
    updateFlags: ()=>{}
});
const $5687937d771f488b$export$d0ecb7c6d0cc6611 = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)($5687937d771f488b$export$a94f9e4f07f0c0a6);
};


const $c47e547dd869dcf0$export$6d7e43f2d6e1c7c6 = ({ children: children , userId: userId , userEmail: userEmail , facilityId: facilityId , territory: territory , defaultFlags: defaultFlags = {} , launchDarklyKey: launchDarklyKey , launchDarklyRelayUrl: launchDarklyRelayUrl , emitErrorEvent: emitErrorEvent  })=>{
    const [flags, setFlags] = react__WEBPACK_IMPORTED_MODULE_1__.useState(defaultFlags);
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_1__.useState(true);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        if (!userId || !userEmail || !facilityId) return;
        const { onReady: onReady , onChange: onChange , onFailed: onFailed , onError: onError  } = $949892c4694f5c47$export$fa0c409881b4c829({
            userId: userId,
            userEmail: userEmail,
            launchDarklyKey: launchDarklyKey,
            launchDarklyRelayUrl: launchDarklyRelayUrl,
            clinicId: facilityId,
            territory: territory
        });
        onReady((allFlags)=>{
            setFlags((currFlags)=>({
                    ...currFlags,
                    ...allFlags
                })
            );
            setLoading(false);
        });
        onChange((newFlags)=>{
            setFlags((currFlags)=>({
                    ...currFlags,
                    ...newFlags
                })
            );
        });
        onFailed((error)=>emitErrorEvent?.({
                name: 'FeatureFlagsProvider.onFailed',
                error: error
            })
        );
        onError((error)=>emitErrorEvent?.({
                name: 'FeatureFlagsProvider.onError',
                error: error
            })
        );
    }, [
        facilityId,
        launchDarklyKey,
        territory,
        userId,
        userEmail,
        setFlags,
        setLoading, 
    ]);
    const updateFlags = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((newFlags)=>setFlags((currFlags)=>({
                ...currFlags,
                ...newFlags
            })
        )
    , [
        setFlags
    ]);
    const value = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>({
            loading: loading,
            flags: flags,
            updateFlags: updateFlags
        })
    , [
        flags,
        loading,
        updateFlags
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($5687937d771f488b$export$a94f9e4f07f0c0a6.Provider, {
        value: value,
        children: children
    });
};



const $d12adac76b8681af$export$61acb772777ef35d = (flagKey)=>{
    const { flags: flags  } = $5687937d771f488b$export$d0ecb7c6d0cc6611();
    const flag = flags[flagKey];
    return !!flag;
};






//# sourceMappingURL=module.js.map


/***/ }),

/***/ 2550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qj": () => (/* binding */ $3d32da261873c082$export$2e2bcd8739ae039),
/* harmony export */   "Vz": () => (/* binding */ $340a2d80affe4902$export$559ed4895514b46c),
/* harmony export */   "hU": () => (/* binding */ $f34bc1239dd20d0b$export$2e2bcd8739ae039),
/* harmony export */   "vt": () => (/* binding */ $d1af298d7c615b2b$export$2e2bcd8739ae039),
/* harmony export */   "zx": () => (/* binding */ $d27b5416a4899700$export$2e2bcd8739ae039)
/* harmony export */ });
/* unused harmony exports ALERT_COLOR, CONSULTATION_COLOR, INVESTIGATION_COLOR, VITALS_COLOR, PRESCRIPTION_COLOR, ALLERGIES_COLOR, PRIMARY_COLOR, TERTIARY_COLOR, SUCCESS_COLOR */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77589);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40374);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69525);
/* harmony import */ var _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10353);
/* harmony import */ var _elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40252);
/* harmony import */ var _elephant_healthcare_mui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46828);











const $340a2d80affe4902$export$35f545774d31b922 = "alert";
const $340a2d80affe4902$export$ef5bec3674131fd9 = "consultation";
const $340a2d80affe4902$export$19a6e50e89e8d753 = "investigation";
const $340a2d80affe4902$export$7e904a91072327d1 = "vitals";
const $340a2d80affe4902$export$4bcf0dcfad54dcfa = "prescription";
const $340a2d80affe4902$export$dcde766283085b5a = "allergies";
const $340a2d80affe4902$export$22791ddad13a5e06 = "primary";
const $340a2d80affe4902$export$559ed4895514b46c = "secondary";
const $340a2d80affe4902$export$975e2d184fe937a4 = "tertiary";
const $340a2d80affe4902$export$8f9af82e21dc022c = "success";
const $340a2d80affe4902$export$9e3dd082ced9a709 = [
    $340a2d80affe4902$export$22791ddad13a5e06,
    $340a2d80affe4902$export$559ed4895514b46c
];



function $9d68a5b10841be8e$var$getPaletteFromColor(color) {
    switch(color.toLowerCase()){
        case 0, $340a2d80affe4902$export$22791ddad13a5e06:
            return 0, $340a2d80affe4902$export$559ed4895514b46c;
        case 0, $340a2d80affe4902$export$559ed4895514b46c:
            return 0, $340a2d80affe4902$export$975e2d184fe937a4;
        case 0, $340a2d80affe4902$export$975e2d184fe937a4:
            return 0, $340a2d80affe4902$export$559ed4895514b46c;
        case 0, $340a2d80affe4902$export$35f545774d31b922:
            return "error";
        default:
            return color.toLowerCase();
    }
}
var $9d68a5b10841be8e$export$2e2bcd8739ae039 = $9d68a5b10841be8e$var$getPaletteFromColor;


/**
 * Custom styles for color as we invert some of
 * mui's practices such as darker on hover.
 */ const $d27b5416a4899700$var$getColorStyles = (theme, { color: color , variant: variant  })=>{
    // TODO: Find out why text variant colours are blocked
    // Horrible temporary hack to get a danger text button but need more time
    // to find out why this is like this or to replace with new Seismic button.
    if (variant === "text" && color !== (0, $340a2d80affe4902$export$35f545774d31b922)) return {};
    const paletteColor = theme.palette[(0, $9d68a5b10841be8e$export$2e2bcd8739ae039)(color)];
    if (color === (0, $340a2d80affe4902$export$975e2d184fe937a4) || variant === "text" && color === (0, $340a2d80affe4902$export$35f545774d31b922)) return {
        background: "none",
        backgroundColor: "transparent",
        color: paletteColor?.main,
        boxShadow: "none",
        "&:hover": {
            background: "none",
            backgroundColor: "transparent",
            boxShadow: "none",
            color: paletteColor?.light
        },
        "$:active": {
            background: "none",
            backgroundColor: "transparent",
            boxShadow: "none",
            color: paletteColor?.dark
        }
    };
    return {
        backgroundColor: paletteColor?.main,
        ...paletteColor?.contrastText ? {
            color: paletteColor?.contrastText
        } : {},
        minWidth: "124px",
        "&:hover": {
            backgroundColor: paletteColor?.light
        },
        "&:active": {
            backgroundColor: paletteColor?.dark
        }
    };
};
const $d27b5416a4899700$var$useStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_4__/* .makeStyles */ .Z)((theme)=>({
        root: (props)=>({
                ...$d27b5416a4899700$var$getColorStyles(theme, props)
            }),
        startIcon: ({ loading: loading  })=>({
                visibility: loading ? "hidden" : "visible"
            })
    }));
const $d27b5416a4899700$var$useLocalStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_4__/* .makeStyles */ .Z)({
    children: ({ loading: loading  })=>({
            visibility: loading ? "hidden" : "visible",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }),
    loader: {
        position: "absolute"
    }
});
function $d27b5416a4899700$var$Button({ children: children = [] , color: color = (0, $340a2d80affe4902$export$22791ddad13a5e06) , classes: overrideClasses = {} , disabled: disabled = false , loading: loading = false , variant: variant = "contained" , ...props }) {
    const classes = {
        ...$d27b5416a4899700$var$useStyles({
            color: color,
            loading: loading,
            variant: variant,
            ...props
        }),
        ...overrideClasses
    };
    const localClasses = $d27b5416a4899700$var$useLocalStyles({
        loading: loading
    });
    // We have custom overrides of this prop - mui does not accept them all
    const colorProp = (0, $340a2d80affe4902$export$9e3dd082ced9a709).includes(color) ? {
        color: color
    } : {};
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), {
        ...props,
        variant: variant,
        classes: classes,
        ...colorProp,
        disabled: disabled || loading,
        children: [
            /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: localClasses.children,
                children: children
            }),
            loading && /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
                color: "inherit",
                size: 22,
                thickness: 5,
                className: localClasses.loader
            })
        ]
    });
}
var $d27b5416a4899700$export$2e2bcd8739ae039 = $d27b5416a4899700$var$Button;







const $f34bc1239dd20d0b$var$muiColors = [
    (0, $340a2d80affe4902$export$22791ddad13a5e06),
    (0, $340a2d80affe4902$export$559ed4895514b46c)
];
const $f34bc1239dd20d0b$var$useStyles = (0, _material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((theme)=>({
        root: (props)=>{
            const paletteColor = theme.palette[(0, $9d68a5b10841be8e$export$2e2bcd8739ae039)(props.color)];
            return {
                color: paletteColor.main,
                "&:hover": {
                    color: paletteColor.light
                },
                "&:active": {
                    color: paletteColor.dark
                },
                padding: theme.spacing()
            };
        }
    }));
function $f34bc1239dd20d0b$var$IconButton({ children: children , color: color = (0, $340a2d80affe4902$export$22791ddad13a5e06) , classes: overrideClasses = {} , disabled: disabled = false , ...props }) {
    const classes = {
        ...$f34bc1239dd20d0b$var$useStyles({
            color: color
        }),
        ...overrideClasses
    };
    // We have custom overrides of this prop - mui does not accept them all
    const colorProp = $f34bc1239dd20d0b$var$muiColors.includes(color) ? {
        color: color
    } : {};
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), {
        ...props,
        classes: classes,
        ...colorProp,
        disabled: disabled,
        children: children
    });
}
var $f34bc1239dd20d0b$export$2e2bcd8739ae039 = $f34bc1239dd20d0b$var$IconButton;


/* eslint-disable react/require-default-props */ 




function $3d32da261873c082$export$2e2bcd8739ae039({ to: to , replace: replace , linkClassName: linkClassName , ...buttonProps }) {
    const visualButton = /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, $d27b5416a4899700$export$2e2bcd8739ae039), {
        ...buttonProps
    });
    // Following a11y best practices for disabling links:
    // https://a11y-guidelines.orange.com/en/articles/disable-elements/
    if (buttonProps.disabled) return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($3d32da261873c082$var$UnstyledAnchor, {
        className: linkClassName,
        role: "link",
        "aria-disabled": true,
        children: visualButton
    });
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_2__/* .UnstyledLink */ .H), {
        to: to,
        replace: replace,
        className: linkClassName,
        children: visualButton
    });
}
const $3d32da261873c082$var$UnstyledAnchor = (0, _material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("a")({
    color: "inherit",
    textDecoration: "none"
});







const $d1af298d7c615b2b$var$useBinButtonStyles = (0, _material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((theme)=>({
        icon: {
            fill: ({ disabled: disabled  })=>disabled ? "currentColor" : theme.palette.error.main
        }
    }));
const $d1af298d7c615b2b$var$BinButton = /*#__PURE__*/ (0, react__WEBPACK_IMPORTED_MODULE_1__).forwardRef(({ title: title = "delete" , ariaLabel: ariaLabel = "delete" , ...props }, ref)=>{
    const classes = $d1af298d7c615b2b$var$useBinButtonStyles(props);
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, $f34bc1239dd20d0b$export$2e2bcd8739ae039), {
        "aria-label": ariaLabel,
        title: title,
        ...props,
        children: /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _elephant_healthcare_mui_icon__WEBPACK_IMPORTED_MODULE_3__.BinIcon), {
            "data-testid": "bin-icon",
            className: classes.icon,
            ref: ref
        })
    });
});
var $d1af298d7c615b2b$export$2e2bcd8739ae039 = $d1af298d7c615b2b$var$BinButton;






//# sourceMappingURL=module.js.map


/***/ }),

/***/ 21534:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jy": () => (/* binding */ $9966448aee17410e$export$2e2bcd8739ae039),
/* harmony export */   "L3": () => (/* binding */ $9b0f8169514ba111$export$639986132714b5bd),
/* harmony export */   "Tq": () => (/* binding */ $2427260f2a6601a7$export$2e2bcd8739ae039),
/* harmony export */   "Zb": () => (/* binding */ $13bbd340b2c57ecb$export$2e2bcd8739ae039),
/* harmony export */   "_R": () => (/* binding */ $67712606cb7d354e$export$2e2bcd8739ae039),
/* harmony export */   "eW": () => (/* binding */ $d10dd0fbaa0dbd69$export$2e2bcd8739ae039),
/* harmony export */   "ll": () => (/* binding */ $20d3293abf5e659c$export$2e2bcd8739ae039),
/* harmony export */   "u0": () => (/* binding */ $cd556f4967c8df13$export$2e2bcd8739ae039)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84875);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74150);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92473);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95061);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41706);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61800);
/* harmony import */ var _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10353);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90898);












let $9b0f8169514ba111$export$639986132714b5bd;
(function(CardColors) {
    CardColors["PRIMARY"] = "primary";
    CardColors["SECONDARY"] = "secondary";
    CardColors["CONSULTATION"] = "consultation";
    CardColors["PRESCRIPTION"] = "prescription";
    CardColors["INVESTIGATION"] = "investigation";
    CardColors["DEFAULT"] = "default";
    CardColors["DISABLED"] = "disabled";
})($9b0f8169514ba111$export$639986132714b5bd || ($9b0f8169514ba111$export$639986132714b5bd = {}));


const $e6d90c6199b708e2$export$49e99cd9a6ce8b74 = (theme, color)=>{
    switch(color){
        case (0, $9b0f8169514ba111$export$639986132714b5bd).DEFAULT:
            return "transparent";
        case (0, $9b0f8169514ba111$export$639986132714b5bd).DISABLED:
            return theme.palette.grey.discreetText;
        default:
            return theme.palette[color].main;
    }
};



const $61b729a3600b50f0$export$d0b2ee33ebf7d64 = /*#__PURE__*/ (0, react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);



const $13bbd340b2c57ecb$var$useStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .makeStyles */ .Z)((theme)=>({
        root: ({ color: color  })=>{
            const borderLeftColor = (0, $e6d90c6199b708e2$export$49e99cd9a6ce8b74)(theme, color);
            return {
                borderLeft: `0.5rem solid ${borderLeftColor}`,
                padding: theme.spacing(2),
                marginBottom: theme.spacing(3),
                overflow: "hidden"
            };
        }
    }));
const $13bbd340b2c57ecb$var$Card = ({ children: children , color: color , expandable: expandable , defaultExpanded: defaultExpanded , className: className , classes: overrideClasses , ...props })=>{
    const classes = {
        ...$13bbd340b2c57ecb$var$useStyles({
            color: color
        }),
        ...overrideClasses
    };
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
        elevation: 2,
        className: (0, (classnames__WEBPACK_IMPORTED_MODULE_2___default()))(classes?.root, className),
        ...props,
        children: /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, $61b729a3600b50f0$export$d0b2ee33ebf7d64).Provider, {
            value: {
                defaultExpanded: defaultExpanded,
                expandable: expandable
            },
            children: children
        })
    });
};
$13bbd340b2c57ecb$var$Card.defaultProps = {
    expandable: false,
    defaultExpanded: false,
    color: (0, $9b0f8169514ba111$export$639986132714b5bd).DEFAULT,
    classes: {},
    className: ""
};
var $13bbd340b2c57ecb$export$2e2bcd8739ae039 = $13bbd340b2c57ecb$var$Card;







const $d10dd0fbaa0dbd69$var$Accordion = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .withStyles */ .D)({
    root: {
        "&.Mui-expanded": {
            margin: 0
        }
    }
})((props)=>/*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), {
        elevation: 0,
        ...props
    }));
const $d10dd0fbaa0dbd69$var$CardBody = ({ children: children  })=>{
    const { expandable: expandable , defaultExpanded: defaultExpanded  } = (0, react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0, $61b729a3600b50f0$export$d0b2ee33ebf7d64));
    if (expandable) return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($d10dd0fbaa0dbd69$var$Accordion, {
        defaultExpanded: defaultExpanded,
        children: children
    });
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment), {
        children: children
    });
};
var $d10dd0fbaa0dbd69$export$2e2bcd8739ae039 = $d10dd0fbaa0dbd69$var$CardBody;








const $9966448aee17410e$var$AccordionSummary = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .withStyles */ .D)((theme)=>({
        root: {
            alignItems: "flex-start",
            padding: theme.spacing(2),
            margin: theme.spacing(-2),
            minHeight: "auto",
            "&.Mui-expanded": {
                minHeight: "auto"
            }
        },
        content: {
            margin: 0,
            paddingRight: theme.spacing(2),
            "&.Mui-expanded": {
                margin: 0
            }
        },
        expandIcon: {
            margin: theme.spacing(-1)
        }
    }))((props)=>/*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
        ...props
    }));
const $9966448aee17410e$var$useStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .makeStyles */ .Z)({
    expandMoreIcon: {
        fontSize: 24
    }
});
const $9966448aee17410e$var$CardSummary = ({ children: children , ...props })=>{
    const { expandable: expandable  } = (0, react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0, $61b729a3600b50f0$export$d0b2ee33ebf7d64));
    const classes = $9966448aee17410e$var$useStyles();
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment), {
        children: expandable ? /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($9966448aee17410e$var$AccordionSummary, {
            expandIcon: /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), {
                className: classes.expandMoreIcon,
                color: "secondary"
            }),
            children: /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), {
                flex: 1,
                ...props,
                children: children
            })
        }) : /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), {
            flex: 1,
            ...props,
            children: children
        })
    });
};
var $9966448aee17410e$export$2e2bcd8739ae039 = $9966448aee17410e$var$CardSummary;







const $cd556f4967c8df13$var$AccordionDetails = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .withStyles */ .D)({
    root: {
        display: "block",
        padding: 0
    }
})((props)=>/*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z), {
        ...props
    }));
const $cd556f4967c8df13$var$CardDetails = ({ children: children  })=>{
    const { expandable: expandable  } = (0, react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0, $61b729a3600b50f0$export$d0b2ee33ebf7d64));
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), {
        pt: 2,
        children: expandable ? /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($cd556f4967c8df13$var$AccordionDetails, {
            children: children
        }) : /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment), {
            children: children
        })
    });
};
var $cd556f4967c8df13$export$2e2bcd8739ae039 = $cd556f4967c8df13$var$CardDetails;







const $2427260f2a6601a7$var$useStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .makeStyles */ .Z)((theme)=>({
        footerItem: {
            fontSize: 12,
            color: theme.palette.text.discreet
        }
    }));
const $2427260f2a6601a7$var$CardFooterItem = ({ children: children , className: className , ...props })=>{
    const classes = $2427260f2a6601a7$var$useStyles();
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z), {
        className: (0, (classnames__WEBPACK_IMPORTED_MODULE_2___default()))(classes.footerItem, className),
        ...props,
        children: children
    });
};
$2427260f2a6601a7$var$CardFooterItem.defaultProps = {
    className: ""
};
var $2427260f2a6601a7$export$2e2bcd8739ae039 = $2427260f2a6601a7$var$CardFooterItem;





const $20d3293abf5e659c$var$CardTitle = ({ children: children  })=>{
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z), {
        variant: "h5",
        children: children
    });
};
var $20d3293abf5e659c$export$2e2bcd8739ae039 = $20d3293abf5e659c$var$CardTitle;







const $67712606cb7d354e$var$useStyles = (0, _elephant_healthcare_mui_style__WEBPACK_IMPORTED_MODULE_3__/* .makeStyles */ .Z)((theme)=>({
        subtitle: ({ color: color  })=>({
                fontSize: 12,
                color: (0, $e6d90c6199b708e2$export$49e99cd9a6ce8b74)(theme, color)
            })
    }));
const $67712606cb7d354e$var$CardSubtitle = ({ children: children , color: color , ...props })=>{
    const classes = $67712606cb7d354e$var$useStyles({
        color: color
    });
    return /*#__PURE__*/ (0, react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((0, _material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z), {
        className: classes.subtitle,
        ...props,
        children: children
    });
};
var $67712606cb7d354e$export$2e2bcd8739ae039 = $67712606cb7d354e$var$CardSubtitle;






//# sourceMappingURL=module.js.map


/***/ }),

/***/ 85810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ $aa40b54b76104bb5$export$2e2bcd8739ae039),
/* harmony export */   "O": () => (/* binding */ $81d4b21b84201637$export$2e2bcd8739ae039)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82682);







const $aa40b54b76104bb5$var$useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((theme)=>({
        root: {
            backgroundColor: (props)=>theme.palette[props.color].main
            ,
            color: (props)=>theme.palette[props.color].contrastText
            ,
            textTransform: 'capitalize',
            fontWeight: theme.typography.fontWeightBold,
            fontSize: theme.typography.fontSize,
            borderRadius: theme.shape.borderRadius,
            height: 24
        }
    })
);
function $aa40b54b76104bb5$var$Chip(props) {
    const { color: color = 'primary' , label: label  } = props;
    const classes = $aa40b54b76104bb5$var$useStyles({
        color: color
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        label: label,
        classes: {
            root: classes.root
        }
    });
}
var $aa40b54b76104bb5$export$2e2bcd8739ae039 = $aa40b54b76104bb5$var$Chip;





const $81d4b21b84201637$var$DifferenceChip = ({ difference: difference  })=>{
    let chipProps;
    if (difference === 0) chipProps = {
        color: 'darkerGrey',
        label: `${difference}`
    };
    else if (difference > 0) chipProps = {
        color: 'primary',
        label: `+ ${difference}`
    };
    else chipProps = {
        color: 'prescription',
        label: `- ${Math.abs(difference)}`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($aa40b54b76104bb5$export$2e2bcd8739ae039, {
        ...chipProps
    });
};
var $81d4b21b84201637$export$2e2bcd8739ae039 = $81d4b21b84201637$var$DifferenceChip;





//# sourceMappingURL=module.js.map


/***/ }),

/***/ 11559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ addClass)
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),

/***/ 44581:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ removeClass)
/* harmony export */ });
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ })

}]);